import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { PhoneNumberOutputData } from '@sc/data-access-models';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../button';
import {
  ReactiveFormsModule,
  FormsModule,
  FormGroup,
  FormBuilder,
} from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { IconComponent } from '../icon';
import { ConfigurationService } from '@sc/data-access-configuration';
import { PhoneInputComponent } from '../phone';

@Component({
  selector: 'sc-phone-number-sheet',
  styleUrls: ['./phone-number-sheet.component.scss'],
  encapsulation: ViewEncapsulation.None,
  template: `
    <div class="phone-number-container">
      <div class="close">
        <button
          type="button"
          class="close-btn"
          (click)="onButtonClick('cancel')"
        >
          <span class="sr_only">{{
            'GlobalApplicativeConstants.accessibility.closeDialog'
              | translate
                : { dialogTitle: 'PhoneNumberSheet.mainTitle' | translate }
          }}</span>
          <sc-icon name="close"></sc-icon>
        </button>
      </div>
      <h1
        mat-dialog-title
        id="abandon-dossier-fitter-title-id"
        [innerHTML]="'PhoneNumberSheet.mainTitle' | translate"
      ></h1>

      <h2 class="sc-design-text-3">
        {{ 'PhoneNumberSheet.subTitle' | translate }}
      </h2>
      <form id="phone-number-sheet-form" [formGroup]="form">
        <sc-phone-input
          formControlName="phoneNumberABTest"
          [label]="'PhoneNumberSheet.phoneInput' | translate"
          scKeyPress="phoneNumberABTest"
          [displayCountrySelection]="true"
          [setCountry]="form.get('phoneCountry').value"
          (changeCountry)="onCountryChange($event)"
        ></sc-phone-input>
      </form>
      <span class="phone-number-sheet-btns">
        <sc-button
          id="saveBtn"
          buttonType="primary"
          [disabled]="!form.get('phoneNumberABTest').value"
          (click)="onButtonClick('save')"
          >{{ 'PhoneNumberSheet.saveBtn' | translate }}</sc-button
        >
      </span>
    </div>
  `,
  imports: [
    IconComponent,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule,
    ButtonComponent,
    TranslateModule,
    PhoneInputComponent,
  ],
})
export class PhoneNumberSheetComponent implements OnInit {
  @Output()
  private readonly phoneNumberResult = new EventEmitter<PhoneNumberOutputData>();
  form: FormGroup;

  constructor(
    private readonly formBuilder: FormBuilder,
    public configurationService: ConfigurationService
  ) {}

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      phoneNumberABTest: [''],
      phoneCountry: [this.configurationService.getDefaultPhoneNumberCountry()],
    });
  }

  onCountryChange(country) {
    const control = this.form.get('phoneCountry');
    if (control && control.value !== country) {
      control.setValue(country, { emitEvent: false });
    }
  }

  onButtonClick(clickEvent) {
    if (clickEvent === 'save') {
      this.phoneNumberResult.emit({
        type: clickEvent,
        phoneNumber: this.form.get('phoneNumberABTest').value,
        phoneNumberCountry: this.form.get('phoneCountry').value,
      });
    } else {
      this.phoneNumberResult.emit({ type: clickEvent });
    }
  }
}
